"use client";

import { Heading } from "@components/ui";

import { useEffect } from "react";
import { useCheckoutContext, useCheckoutZipCode } from "./Checkout.hooks";
import { checkoutStore } from "./Checkout.store";
import Delivery from "./delivery/Delivery";

export default function CheckoutDelivery() {
  const { dictionary } = useCheckoutContext();
  const zipcode = useCheckoutZipCode();
  const ableToComplete = checkoutStore((state) => state.ableToComplete);
  const hasSetAddress = checkoutStore((state) => state.hasSetAddress);
  const setDeliveryOption = checkoutStore((state) => state.setDeliveryOption);

  useEffect(() => {
    if (!ableToComplete) {
      setDeliveryOption(undefined);
    }
  }, [ableToComplete, setDeliveryOption]);

  if (!zipcode) {
    return null;
  }

  if (!ableToComplete || !hasSetAddress) return null;

  return (
    <div className="px-5 py-6 lg:px-16 lg:py-10">
      {dictionary.checkoutDeliveryHeading && (
        <Heading size={5} className="mb-6 text-center">
          {dictionary.checkoutDeliveryHeading}
        </Heading>
      )}
      <Delivery />
    </div>
  );
}
